/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

export const useShowLoaderAndSignInMsg = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [showSignInMessage, setShowSignInMessage] = useState(false);

  const member = useSelector((state) => get(state, ["member"]));
  const memberLoaded = useSelector((state) => get(state, ["memberLoaded"], false));
  const memberSubscriptionsLoaded = useSelector((state) => get(state, ["memberSubscriptionsLoaded"], false));

  useEffect(() => {
    if (memberLoaded) {
      if (member && member["verification-status"]) {
        // user is signed in
        setShowSignInMessage(false);
        setShowLoader(true);
        if (memberSubscriptionsLoaded) {
          setShowLoader(false);
        }
      } else {
        setShowLoader(false);
        setShowSignInMessage(true);
      }
    }
  }, [memberLoaded, member, memberSubscriptionsLoaded]);

  return { showLoader, showSignInMessage };
};
